module.exports = __webpack_public_path__ + "static/5-951dc8e9b33d59a38af2286e163af9bb.jpeg";